import Image from 'next/image';

import { GAME_CAROUSEL, MUTED_GRAY } from '../constants';

export function GameCarousel() {
  const items = [...GAME_CAROUSEL, ...GAME_CAROUSEL, ...GAME_CAROUSEL];

  return (
    <div className='relative overflow-hidden'>
      <div className='eu-game-carousel flex gap-6 px-4'>
        {items.map((game, i) => (
          <div key={`${game.name}-${i}`} className='group flex shrink-0 flex-col items-center gap-3'>
            <div className='relative h-[220px] w-[160px] overflow-hidden rounded-2xl border border-white/10 bg-white/5 transition-all duration-300 group-hover:scale-105 group-hover:border-[#93FF18]/40'>
              <Image src={game.image} alt={game.name} fill className='object-cover' sizes='160px' />
            </div>
            <span className='whitespace-nowrap text-center text-sm font-semibold' style={{ color: MUTED_GRAY }}>
              {game.name}
            </span>
          </div>
        ))}
      </div>

      <div className='pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-[#080809] to-transparent md:w-24' />
      <div className='pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-[#080809] to-transparent md:w-24' />

      <style>{`
        @keyframes euGameCarousel {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .eu-game-carousel {
          animation: euGameCarousel 40s linear infinite;
        }
        .eu-game-carousel:hover {
          animation-play-state: paused;
        }
        /* transform is physical — CSS never mirrors it for writing direction. The items overflow the
           track to the right in LTR and to the LEFT under the dir="rtl" that /sa inherits from <html>,
           so there the negative shift uncovers the right edge of the clip box instead of feeding it.
           The content is tripled, so the loop travels a third. Only animation-name is overridden. */
        @keyframes euGameCarouselRtl {
          0% { transform: translateX(0); }
          100% { transform: translateX(33.333%); }
        }
        [dir='rtl'] .eu-game-carousel {
          animation-name: euGameCarouselRtl;
        }
      `}</style>
    </div>
  );
}
